<template>
    <div class="vue-modal relative">
        <div id="authentication-modal" @click.self="SET_SHOW_MODAL_IMAGE(false)" tabindex="-1" aria-hidden="true" class="flex h-full bg-black bg-opacity-70 transition-opacity duration-300 overflow-hidden fixed top-0 right-0 left-0 z-[99] w-full md:inset-0 justify-center items-center">
            <button @click="SET_SHOW_MODAL_IMAGE(false)" type="button" class="absolute top-3 right-2.5 text-white bg-transparent hover:bg-gray-200 hover:text-gray-900 text-sm p-1.5 ml-auto inline-flex items-center" data-modal-toggle="authentication-modal">
                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
            <main class="flex justify-center items-center w-full h-full">
                <img alt="nature" class="max-w-full max-h-full object-contain" :src="getImage.filename" />
            </main>
            <button @click="prevImage" v-if="currentIndex > 0" type="button" class="absolute top-1/2 left-2.5 text-white bg-transparent hover:bg-gray-200 hover:text-gray-900 text-sm p-1.5 ml-auto inline-flex items-center rounded-full" data-modal-toggle="authentication-modal">
                <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg>
            </button>
            <button @click="nextImage" v-if="currentIndex < this.getImages.length - 1" type="button" class="absolute top-1/2 right-2.5 text-white bg-transparent hover:bg-gray-200 hover:text-gray-900 text-sm p-1.5 ml-auto inline-flex items-center rounded-full" data-modal-toggle="authentication-modal">
                <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg>
            </button>
            <div class="absolute bottom-2 left-1/2 transform -translate-x-1/2 text-white text-lg">
                {{ currentIndex + 1 }}/{{ totalImages }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: "ModalImagem",
    methods: {
        ...mapMutations(['SET_SHOW_MODAL_IMAGE', 'SET_IMAGE']),
        
        prevImage() {
            const currentIndex = this.getImages.findIndex(img => img.id === this.getImage.id);
            this.SET_IMAGE(this.getImages[currentIndex - 1]);
        },

        nextImage() {
            const currentIndex = this.getImages.findIndex(img => img.id === this.getImage.id);
            this.SET_IMAGE(this.getImages[currentIndex + 1]);
        },

        handleKeyDown(event) {
            if (event.key === 'ArrowLeft') {
                this.prevImage();
            } else if (event.key === 'ArrowRight') {
                this.nextImage();
            } else if (event.key === 'Escape') {
                this.SET_SHOW_MODAL_IMAGE(false);
            }
        }
    },
    computed: {
        ...mapGetters(['getImage', 'getImages']),
        currentIndex() {
            return this.getImages.findIndex(img => img.id === this.getImage.id);
        },
        totalImages() {
            return this.getImages.length;
        }
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
};
</script>
